import SecurityQuestion from "Models/Security/SecurityQuestionModel";
import SecurityQuestionAnswerModel from "Models/Security/SecurityQuestionAnswerModel";

export default class UserSecurityQuestionsModel {
    allSecurityQuestions: SecurityQuestion[];
    securityQuestionAnswers: SecurityQuestionAnswerModel[];
}
